import { useEffect, useState } from 'react';
import Image from 'next/image';
import Button from '@next-app/components/elements/Button/Button';
import classes from './product-view.module.scss';
import Conditional from '@next-app/components/Conditional';
import { ViewerProps } from '@next-app/interface/PDP/PDPProductView';

const ProductModal = ({ data, serverUrl, modalCurrentImage }: ViewerProps) => {
  const filteredData = data.filter(
    (items: any) => items.viewerType !== 'VideoViewer',
  );

  const [currentImage, setCurrentImage] = useState('');
  const [thumbnailIndex, setThumbnailIndex] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isDownArrowDisabled, setIsDownArrowDisabled] = useState(false);
  const [isUpArrowDisabled, setIsUpArrowDisabled] = useState(true);
  const thumbnailsPerPage = 6;

  useEffect(() => {
    if (modalCurrentImage != currentImage) {
      setCurrentImage(modalCurrentImage || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalCurrentImage]);

  const onHandleThumbnailHover = (data: string) => {
    setCurrentImage(data);
  };

  const handleThumbnailClick = (data: string, index: number) => {
    setCurrentImage(data);
    setSelectedIndex(index);
  };

  const handleScroll = (direction: 'up' | 'down') => {
    setThumbnailIndex((prevIndex) => {
      let newIndex =
        direction === 'down'
          ? prevIndex + thumbnailsPerPage
          : prevIndex - thumbnailsPerPage;

      newIndex = Math.max(0, Math.min(newIndex, filteredData.length - 1));
      setIsDownArrowDisabled(newIndex + thumbnailsPerPage >= data.length);
      setIsUpArrowDisabled(newIndex <= 0);
      return newIndex;
    });
  };

  const hasMoreThanSixThumbnail = filteredData.length > thumbnailsPerPage;
  const isThumbnailVisible = filteredData.length > 1;

  return (
    <div className={`d-flex ${classes['product-modal-body-wrapper']}`}>
      <div className={`position-relative ${classes['product-modal-body']}`}>
        <Conditional if={isThumbnailVisible}>
          <div
            className={`overflow-hidden ${classes['product-modal-open-popup']}`}
            style={{}}
          >
            <div
              className={`position-relative ${classes['thumbnail-container']} ${classes['modal']}`}
              role="list"
              aria-label="thumbnail-container"
              style={{
                transform: `translateY(-${(thumbnailIndex / filteredData.length) * 100}%)`,
                transition: 'transform 0.3s ease',
              }}
            >
              {filteredData.map((item: any, index: number) => (
                <div
                  key={item?.id}
                  className={`ll-link-cursor ${classes['thumbnail-item']}`}
                >
                  <Image
                    className={`${currentImage === item.asset ? classes.active : classes.others}`}
                    src={item.thumbnailCard}
                    alt={item.alt}
                    width={100}
                    height={81}
                    quality={100}
                    unoptimized={true}
                    onMouseOver={() => onHandleThumbnailHover(item?.asset)}
                    onClick={() => handleThumbnailClick(item?.asset, index)}
                  />
                </div>
              ))}
            </div>
          </div>
        </Conditional>

        <Conditional if={hasMoreThanSixThumbnail}>
          <div
            className={`d-flex justify-content-around ${classes.arrowContainer}`}
          >
            <button
              data-testid="scroll-up-button"
              aria-label="Scroll Up"
              className={`${classes.arrow} ${classes.arrowUp} ${isUpArrowDisabled ? classes.disabled : ''}`}
              onClick={() => !isUpArrowDisabled && handleScroll('up')}
              disabled={isUpArrowDisabled}
            ></button>
            <button
              data-testid="scroll-down-button"
              aria-label="Scroll Down"
              className={`${classes.arrow} ${classes.arrowDown} ${isDownArrowDisabled ? classes.disabled : ''}`}
              onClick={() => !isDownArrowDisabled && handleScroll('down')}
              disabled={isDownArrowDisabled}
            ></button>
          </div>
        </Conditional>
      </div>

      <div
        className={`d-flex flex-column justify-content-center align-items-center ${classes['modal-image-wrapper']}`}
      >
        <Image
          src={`${serverUrl}${currentImage}?wid=800&fmt=jpeg&qlt=85,1&pscan=auto&op_sharpen=0&resMode=sharp2&op_usm=1,0.65,6,0`}
          alt="Hovered"
          width={800}
          height={600}
          quality={100}
          unoptimized={true}
        />

        <Button data-bs-dismiss="modal" variant="transparent">
          <span
            className={`ls-icon position-relative ${classes['icn-x-close-lgt-circle']}`}
          ></span>
          <span className={`ll-fs-14 ${classes['icn-x-close-text']}`}>
            Close Window
          </span>
        </Button>
      </div>
    </div>
  );
};

export default ProductModal;
